import treeItemShape from "../../shapes/treeItemShape";
import Icon from "../Icon";

type Props = {
  treeItem: treeItemShape;
  selectedItems: treeItemShape[];
  onChange: $TSFixMeFunction;
  disabled?: boolean;
  showIsEndress?: boolean;
};

function TreeItem({
  treeItem,
  onChange,
  selectedItems,
  disabled,
  showIsEndress,
}: Props) {
  const isDetailsOpen = selectedItems.find(
    (selectedItem) => selectedItem.code === treeItem.code,
  );

  const isChildSelected = (item: $TSFixMe) =>
    item.children.some((child: $TSFixMe) => {
      if (
        selectedItems.find((selectedItem) => selectedItem.code === child.code)
      )
        return true;
      if (child.children.length > 0) return isChildSelected(child);
      return false;
    });

  const getSelectedChildrenCount = (item: $TSFixMe) =>
    item.children.reduce((acc: $TSFixMe, child: $TSFixMe) => {
      let count = acc;
      if (
        selectedItems.find((selectedItem) => selectedItem.code === child.code)
      )
        count += 1;
      if (child.children.length > 0) count += getSelectedChildrenCount(child);
      return count;
    }, 0);

  const isEndress =
    showIsEndress &&
    // @ts-expect-error TS(2339) FIXME: Property 'tenant' does not exist on type 'treeItem... Remove this comment to see the full error message
    (treeItem.tenant?.name && treeItem.tenant?.public ? (
      <span className="tenant-option-icon">
        <Icon name="icon3-eh-radio-button-checked" />
      </span>
    ) : null);

  return (
    <li key={`tree-item-${treeItem.id}`}>
      {/* @ts-expect-error TS(2322) FIXME: Type 'treeItemShape | undefined' is not assignable... Remove this comment to see the full error message */}
      <details open={isDetailsOpen} disabled={disabled}>
        {/* @ts-expect-error TS(2322) FIXME: Type '{ children: any[]; "aria-label": boolean; }'... Remove this comment to see the full error message */}
        <summary aria-label={treeItem.children.length > 0}>
          <input
            id={`${treeItem.code}-checkbox`}
            type="checkbox"
            checked={!!selectedItems.find((i) => i.code === treeItem.code)}
            value={treeItem.code}
            disabled={disabled}
            onChange={() => onChange(treeItem)}
          />
          <label title={treeItem.name} htmlFor={`${treeItem.code}-checkbox`}>
            {treeItem.name}
          </label>
          {isEndress}
          {isChildSelected(treeItem) && (
            <span className="badge">{getSelectedChildrenCount(treeItem)}</span>
          )}
        </summary>
        {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
        {treeItem.children.length > 0 && (
          <ul>
            {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
            {treeItem.children.map((childItem: $TSFixMe) => (
              <TreeItem
                key={`child-${childItem.id}`}
                treeItem={childItem}
                selectedItems={selectedItems}
                onChange={onChange}
                disabled={disabled}
                showIsEndress={showIsEndress}
              />
            ))}
          </ul>
        )}
      </details>
    </li>
  );
}

export default TreeItem;
